import { deferred } from '../util';
const serviceData = {};
const SERVICE_REGEX = /^[\/]*([^\/]+)(?:\/.*)?$/;
export const getServiceNameFromUrl = url => {
  // just handle relative urls as non relative urls could be cross origin and/or non SAS endpoints
  if (typeof url !== 'string' || url[0] !== '/') {
    return null;
  }
  const matches = SERVICE_REGEX.exec(url);
  if (!matches) {
    return null;
  }
  return matches[1];
};

/**
 * Nova Axios manages certain data for services. This provides a common place to store and access it.
 * @param serviceName Name of the service as determined by its URL
 * @returns
 */
export const getServiceData = serviceName => {
  return serviceData[serviceName] ?? null;
};
export const resolveThrottle = serviceName => {
  if (!serviceName) {
    return;
  }
  const throttle = serviceData[serviceName].throttle;
  if (!throttle || throttle.complete) {
    return;
  }
  throttle.complete = true;
  clearTimeout(throttle.timerId);
  throttle.resolve();
};

/**
 * Returns service data object. If it doesn't exist, it creates it.
 * @param serviceName
 * @returns
 */
export const initGetServiceData = serviceName => {
  if (!serviceData[serviceName]) {
    serviceData[serviceName] = {};
  }
  return serviceData[serviceName];
};
const maxThrottleDelayInMilliseconds = 30000;
let throttleCount = 0;
export const createThrottle = serviceName => {
  const {
    promise,
    resolve
  } = deferred();
  const throttleId = `${serviceName}-${throttleCount++}`;
  initGetServiceData(serviceName).throttle = {
    promise,
    complete: false,
    resolve,
    throttleId,
    timerId: window.setTimeout(() => {
      resolveThrottle(serviceName);
    }, maxThrottleDelayInMilliseconds)
  };
  return throttleId;
};
//# sourceMappingURL=services.js.map